module.exports = __webpack_public_path__ + "media/images/icons/arrow_circle_up-77857baf7a1ef4e071eab8b7c6f91e31.svg";